import { ReactElement } from 'react';
import ForgetPasswordPage from './views';

const ForgetPasswordRoute = (props:any): ReactElement => (
  <ForgetPasswordPage loginData={props.loginData}/>
);

export default ForgetPasswordRoute;
